import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, retrySuccess, retryFailure } from '../../actions/promotion/retry';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* retryPromotion(action) {
  try {
    const { promotionId } = action.payload || {};
    const response = yield call(
      axios.post,
      `${config.API_URL}/deployments/${promotionId}/retry`,
      {},
      { headers: getLocalUser() },
    );
    yield put(retrySuccess(response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(retryFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, retryPromotion);
}
